import {
  EducatorsListingProfilesPersonalListingProfileForm,
  EducatorsListingProfilesTeacherProfileForm,
} from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type PersonalListingProfileProps = {
  listing_profile: EducatorsListingProfilesPersonalListingProfileForm
  teacher_profile: EducatorsListingProfilesTeacherProfileForm
  teacher_profile_attachments: {
    other_approval_photo_ids: Array<AttachmentAttributes>
    teacher_profile_photo_id: AttachmentAttributes
    teacher_profile_resume: AttachmentAttributes
  }
}

export type PersonalListingProfileParams = {
  listing_profile: Omit<
    EducatorsListingProfilesPersonalListingProfileForm,
    "visible"
  >
  teacher_profile: EducatorsListingProfilesTeacherProfileForm
  teacher_profile_attachments: PersonalListingProfileProps["teacher_profile_attachments"]
}

export type SerialisedPersonalListingProfileParams = {
  listing_profile_json: string
  teacher_profile_json: string
  teacher_profile_attachments: PersonalListingProfileProps["teacher_profile_attachments"]
}

export type SharedParams = PersonalListingProfileParams
export type SerialisedSharedParams = SerialisedPersonalListingProfileParams

export type UpdateParams = SerialisedSharedParams
export type CreateParams = SerialisedSharedParams

export const usePersonalListingProfileProps = () =>
  useProps<PersonalListingProfileProps>()
